import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Typography,
  FormHelperText,
  CardHeader,
} from '@material-ui/core';
import isMobile from 'ismobilejs';
import Orders from '../orders';
import Summary from './Summary';
import {
  columnDataForStatement,
  columnDataForStatementReturns,
  columnDataForStatementReturnedToOnceit,
  monthes,
} from '../common/constants';

const styles = theme => ({
  root: {
    padding: 5,
  },
  heading: {
    fontSize: theme.typography.pxToRem(18),
    flexShrink: 0,
    color: '#FFFFFF',
  },
  expansionPanelSummary: {
    backgroundColor: '#799bfd',
    height: 40,
  },
  expansionPanelDetails: {
    padding: 5,
  },
  container: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: isMobile.phone ? 'calc(90%)' : '200px',
    borderBottom: 0,
  },
  formHelperText: {
    marginLeft: '5px',
    color: '#fd1013',
  },
});

class Summarization extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      summaries: props.summaries ? props.summaries : {},
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ summaries: nextProps.summaries });
  }

  render() {
    const {
      classes,
      pageInfo,
      result,
      handleChangePage,
      handleChangePageSize,
      filters,
    } = this.props;
    const { summaries } = this.state;
    const title = `${filters.year} ${monthes[filters.month]} Statement`;
    return (
      <div className={classes.root} id="statements">
        <CardHeader style={{ textAlign: 'center' }} title={title} />
        <span> Currency: {result && result.currency ? result.currency.toUpperCase() : ''}</span>
        <Summary summaries={summaries} />
        <ExpansionPanel expanded>
          <ExpansionPanelSummary
            className={classes.expansionPanelSummary}
            style={{ minHeight: '40px', cursor: 'default' }}
          >
            <Typography className={classes.heading} color="inherit">
              Orders
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.expansionPanelDetails}>
            <form className={classes.container} noValidate autoComplete="off">
              <Orders
                withOutToolBar
                withOutPagination
                columnData={columnDataForStatement}
                result={result.orders}
                readOnly
                pageInfo={pageInfo}
                isTableOnly
                handleChangePage={handleChangePage}
                handleChangePageSize={handleChangePageSize}
              />
            </form>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel expanded>
          <ExpansionPanelSummary
            className={classes.expansionPanelSummary}
            style={{ minHeight: '40px', cursor: 'default' }}
          >
            <Typography className={classes.heading} color="inherit">
              Credit Items (*)
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.expansionPanelDetails}>
            <form className={classes.container} noValidate autoComplete="off">
              <Orders
                withOutToolBar
                withOutPagination
                columnData={columnDataForStatementReturns}
                result={result.returns}
                readOnly
                pageInfo={pageInfo}
                isTableOnly
                handleChangePage={handleChangePage}
                handleChangePageSize={handleChangePageSize}
              />
            </form>
          </ExpansionPanelDetails>
          <FormHelperText className={classes.formHelperText}>
            <p>
              (*) Credit Items: It is for Damaged / Damaged By Courier / Faulty / Lost By Courier /
              MixUp / Missing / Disliked Alternative / Undersupply / Cancelled
            </p>
          </FormHelperText>
        </ExpansionPanel>

        <ExpansionPanel expanded>
          <ExpansionPanelSummary
            className={classes.expansionPanelSummary}
            style={{ minHeight: '40px', cursor: 'default' }}
          >
            <Typography className={classes.heading} color="inherit">
              Returned to Onceit Items
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.expansionPanelDetails}>
            <form className={classes.container} noValidate autoComplete="off">
              <Orders
                withOutToolBar
                withOutPagination
                columnData={columnDataForStatementReturnedToOnceit}
                result={result.marketplaceReturnToDC}
                readOnly
                pageInfo={pageInfo}
                isTableOnly
                handleChangePage={handleChangePage}
                handleChangePageSize={handleChangePageSize}
              />
            </form>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
    );
  }
}

Summarization.propTypes = {
  summaries: PropTypes.object,
  pageInfo: PropTypes.object,
  result: PropTypes.object,
  filters: PropTypes.object,
  handleChangePage: PropTypes.func,
  handleChangePageSize: PropTypes.func,
};

export default withStyles(styles)(Summarization);



// WEBPACK FOOTER //
// ./src/components/statements/Summarization.js